
export default {
  props: {
    product: {
      type: Object,
      default: () => { },
    },
    nameCategory: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    actionRadio(value) {
      this.$emit('inputData', value);
    },
    openDialog(value) {
      this.actionRadio(value);
       this.dialog = true;
    },
  },
};
